/** Normalised title used to spot the same saved place regardless of case/spacing. */
export const titleKey = (t: string | null | undefined) =>
  (t ?? "").trim().replace(/\s+/g, " ").toLowerCase();
